export function removeNullishFromObjRecursive(obj: any) {
	Object.keys(obj).forEach((key) => {
		if (obj[key] && typeof obj[key] === 'object') {
			if (JSON.stringify(obj[key]) === '[]') {
				delete obj[key];
			} else {
				removeNullishFromObjRecursive(obj[key]);
			}
		} else if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
			delete obj[key];
		}
	});
}
